import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/url_rewrites'

const UrlRewritesApiV2 = {

  /**
   * Create a for Url Rewrite
   * Invoke `POST api/v2/admins/url_rewrites'
   */
  create: async (payload) => {
    const path = API_PATH

    const body = {
      'url_rewrite': payload
    }

    const response = axios.post(path, body)

    return response
  },
  /**
   * Update a for Url Rewrite
   * Invoke `PATCH api/v2/admins/url_rewrites/:id'
   * @param {string} id  Url Rewrite Id
   */
  update: async (id, payload) => {
    const path = `${API_PATH}/${id}`

    const body = {
      'url_rewrite': payload
    }

    const response = axios.patch(path, body)

    return response
  },
  /**
   * Show  Url Rewrite by specific id
   * Invoke `GET api/v2/admins//url_rewrites/:id`
   * @param {number} id  Url Rewrite Id
   */
  getSingle: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = await axios.get(path)

    return response
  },
  /*
   * Get list of  Url Rewrites
   * Invoke `GET api/v2/admins/url_rewrites'
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  }

}

export default UrlRewritesApiV2
